import React from "react";

const HeaderNavItem = ({ navData, setActiveIndex }) => {
  return (
    <li className="nav_item">
      <a className="nav_link" href={navData.mainLink} onClick={setActiveIndex}>
        {navData.mainTitle}
      </a>
    </li>
  );
};

export default HeaderNavItem;
